import AreaChart from "../AreaChart";
import BarChart from "../BarChart";
import GroupedColumnLineChart from "../GroupedColumnLine";
import LineChart from "../LineChart";
import PieChart from "../PieChart";
import ChartType from "../../editorPage/ChartType.json";
import HistogramChart from "../HistogramChart";
import WordCloudChart from "../WordCloudChart";
import RadarChart from "../RadarChart";

export default function Chart({ chartType, chartData, chartConfig }) {
	chartConfig = chartConfig || {};
	chartData = chartData || [];
	switch (chartType) {
		case ChartType.BasicArea:
			return AreaChart(chartData, chartConfig);
		case ChartType.StackedArea:
			chartConfig.isStack = true;
			return AreaChart(chartData, chartConfig);
		case ChartType.BasicBar:
			return BarChart(chartData, chartConfig);
		case ChartType.StackedBar:
			chartConfig.isStack = true;
			return BarChart(chartData, chartConfig);
		case ChartType.PercentBar:
			chartConfig.isPercent = true;
			return BarChart(chartData, chartConfig);
		case ChartType.GroupBar:
			chartConfig.isGroup = true;
			return BarChart(chartData, chartConfig);
		case ChartType.RangeBar:
			chartConfig.isRange = true;
			return BarChart(chartData, chartConfig);
		case ChartType.BasicLine:
			return LineChart(chartData, chartConfig);
		case ChartType.MultiLine:
			chartConfig.isMultiLine = true;
			return LineChart(chartData, chartConfig);
		case ChartType.StepLine:
			chartConfig.isStepLine = true;
			return LineChart(chartData, chartConfig);
		case ChartType.ColumnLine:
			return GroupedColumnLineChart(chartData, chartConfig);
		case ChartType.PieChart:
			return PieChart(chartData, chartConfig);
		case ChartType.DonutChart:
			chartConfig.isDonut = true;
			return PieChart(chartData, chartConfig);
		case ChartType.Histogram:
			return HistogramChart(chartData, chartConfig);
		case ChartType.RadarMultiLine:
			chartConfig.isMultiLine = true;
			return RadarChart(chartData, chartConfig);
		case ChartType.Radar:
			return RadarChart(chartData, chartConfig);
		case ChartType.WordCloud:
			return WordCloudChart(chartData, chartConfig);
		default:
			return null;
	}
}
